<template>
  <div class="deliverable-listing calendar-view">
    <FullCalendar ref="csm__calendar" :options="{...calendarOptions, events: calendarEventUsed}">
      <template v-slot:eventContent='arg'>
        <div :id="'eventNo' + arg.event.id">
          <span v-html="arg.event.extendedProps.deliverable + ' > ' + arg.event.title" v-if="(typeof arg.event.extendedProps.deliverable != 'undefined')" @click="handleEventTitleClick(arg)"></span>
          <span v-else v-html="arg.event.title" @click="handleEventTitleClick(arg)"></span>
        </div>
        <b-tooltip custom-class="calendar-due-date-tooltip" :delay="0" :ref="`eventTooltip${arg.event.id}`" triggers="manual" :target="'eventNo' + arg.event.id" :show="calendarDueDateTooltip[`eventTooltip${arg.event.id}`]">
          Due date: {{ formatDueDateTooltip(arg.event.extendedProps.dueDate) }}
        </b-tooltip>
      </template>
      <template v-slot:dayCellContent='arg'>
        <a id="fc-dom-4" class="fc-daygrid-day-number" :aria-label="$moment(arg.date).format('MMMM DD, YYYY')">{{arg.dayNumberText}}</a>
        <a v-if="$moment.utc(arg.date).isSame($moment.utc(expandDate), 'day')" class="fc-event-hide" title="Collapse" @click.prevent="handleHideClick(arg)">Collapse</a>
      </template>
    </FullCalendar>
  </div>
</template>
<script>
import '@fullcalendar/core/vdom' // solves problem with Vite
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
  },
  computed: {
    ...mapGetters(['deliverableDetail', 'calendarEvents', 'projectDetail', 'taskHighlighted']),

    calendarEventUsed() {
      if (this.expandDate) {
        const targetDate = this.$moment(this.expandDate);
        return this.calendarEvents.filter(x => {
          const startDate = this.$moment.utc(x.start, "YYYY-MM-DD");
          const endDate = this.$moment.utc(x.end, "YYYY-MM-DD");

          return targetDate.isBetween(startDate, endDate, 'day', '[)');
        });
      } else {
        return this.calendarEvents;
      }
    }
  },
  data() {
    let self = this
    return {
      events: [],
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          resourceTimelinePlugin,
          interactionPlugin // needed for dateClick
        ],
        customButtons: {
          collapseButton: {
            text: 'Collapse',
            click: () => {
              this.handleHideClick(this.$refs.csm__calendar.getApi());
            }
          }
        },
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'collapseButton timelineYearView,dayGridMonth,dayGridBiWeekly,dayGridWeek,dayGridDay'
        },
        views: {
          dayGridBiWeekly: {
            type: 'dayGrid',
            duration: { weeks: 2 },
            buttonText: 'Bi-Weekly'
          },
          timelineYearView: {
            type: 'timeline',
            duration: { year: 1 },
            slotDuration: { month: 1 },
            dateIncrement: { year: 1 },
            buttonText: 'Year',
          }
        },
        initialView: 'dayGridBiWeekly',
        height: '100%',
        // eventSources: [{
        //   events(start, callback) {
        //     self.$store.dispatch('getCalendarData').then((response) => {
        //       callback(response.data)
        //     })
        //   }
        // }],
        editable: false,
        selectable: false,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        dateClick: this.handleDateClick,
        eventMouseEnter: this.handleEventMouseEnter,
        eventMouseLeave: this.handleEventMouseLeave,
        eventClassNames: 'mb-2',
        moreLinkClick: this.handleMoreLinkClick,
        /* you can update a remote database when these fire:
        eventAdd:
        eventChange:
        eventRemove:
        */
      },
      renderCount: 0,
      expandedEvents: [],
      expandDate: null,

      calendarDueDateTooltip: {},
      calendarDueDateTooltipStay: false,
    }
  },
  mounted() {
    // this.getCalendarData(this.dataSetType)
    $(".fc-collapseButton-button").attr("disabled", true);

    this.$root.$on('bv::modal::shown', (bvEvent, modalId) => {
      console.log(modalId);
      if (modalId == 'editDeliverableModal') {
        if (this.taskHighlighted) {
            let editModal = $("#editDeliverableModal");

            this.$nextTick(() => {
              setTimeout(() => {
                let curEl = $(".task-fields .field-block.highlight");
                const elOffset = curEl.offset();
                editModal.scrollTop(elOffset.top - 0.4 * window.innerHeight);
              }, 100);
            });
        }
      }
    });
  },
  methods: {
    ...mapActions(['getCalendarData','fetchProjectDeliverableById']),
    ...mapMutations(['setDataLoading']),
    createEventId() {
      let eventGuid = 0
      return String(eventGuid++)
    },

    handleDateSelect(selectInfo) {
      let title = prompt('Please enter a new title for your event')
      let calendarApi = selectInfo.view.calendar

      calendarApi.unselect() // clear date selection

      if (title) {
        calendarApi.addEvent({
          id: this.createEventId(),
          title,
          start: selectInfo.startStr,
          end: selectInfo.endStr,
          allDay: selectInfo.allDay
        })
      }
    },

    handleDateClick(dateClickInfo) {
      this.calendarDueDateTooltipStay = false;
      this.calendarDueDateTooltip = {};
      this.clickedOutsideFilter();
      let existingEvents = dateClickInfo.view.calendar.getEvents();
      existingEvents.forEach(x => {
        x.setProp("classNames", []);
      });
    },

    handleEventClick(clickInfo) {
      this.calendarDueDateTooltipStay = true;
      this.calendarDueDateTooltip = {};
      this.calendarDueDateTooltip[`eventTooltip${clickInfo.event.id}`] = true;
      let existingEvents = clickInfo.view.calendar.getEvents();
      existingEvents.forEach(x => {
        x.setProp("classNames", []);
      });
      clickInfo.event.setProp("classNames", ['selected']);
    },

    handleEventTitleClick(clickInfo) {
      this.clickedOutsideFilter();
      if(typeof clickInfo.event.extendedProps.project != 'undefined') {
        let projectId = clickInfo.event.extendedProps.project_number
        // this.$router.push(`/project/${projectId}`);
        this.goToProject(projectId);
        // this.$store
        //   .dispatch("getProjectDetail", { projectId })
        //   .then(() => {
        //     let currentTitle = document.title.match(/\(\d+\)\s/g);
        //     if(!currentTitle) {
        //       document.title = this.projectDetail.title;
        //     } else {
        //       document.title = currentTitle[0] + this.projectDetail.title;
        //     }
        //     this.$bvModal.show("editProjectModal");
        //   });
      } else if (typeof clickInfo.event.extendedProps.task != 'undefined') {
        let deliverableId = clickInfo.event.extendedProps.deliverableId || clickInfo.event.id;
        this.$store
          .dispatch("getDeliverableDetail", { deliverableId })
          .then(() => {
            let currentTitle = document.title.match(/\(\d+\)\s/g);
            if(!currentTitle) {
              document.title = this.deliverableDetail.title;
            } else {
              document.title = currentTitle[0] + this.deliverableDetail.title;
            }
            this.$store.dispatch("highlightTask", clickInfo.event.id);
            this.$bvModal.show("editDeliverableModal");
          });
      } else {
        // let deliverableId = clickInfo.event.groupId != '' ? clickInfo.event.groupId : clickInfo.event.id
        let deliverableId = clickInfo.event.extendedProps.deliverableId || clickInfo.event.id;
        this.$store
          .dispatch("getDeliverableDetail", { deliverableId })
          .then(() => {
            let currentTitle = document.title.match(/\(\d+\)\s/g);
            if(!currentTitle) {
              document.title = this.deliverableDetail.title;
            } else {
              document.title = currentTitle[0] + this.deliverableDetail.title;
            }
            this.$bvModal.show("editDeliverableModal");
          });
      }
    },

    handleEventMouseEnter(mouseInfo) {
      if (!this.calendarDueDateTooltipStay) this.calendarDueDateTooltip[`eventTooltip${mouseInfo.event.id}`] = true;
      const classArray = Object.assign([], mouseInfo.event.classNames || []);
      classArray.push('hover');
      mouseInfo.event.setProp("classNames", classArray);
      // this.$refs[`eventTooltip${mouseInfo.event.id}`].$emit('open');
    },
    handleEventMouseLeave(mouseInfo) {
      if (!this.calendarDueDateTooltipStay) this.calendarDueDateTooltip[`eventTooltip${mouseInfo.event.id}`] = false;
      const classArray = Object.assign([], mouseInfo.event.classNames || []);
      const newClassArray = classArray.filter(x => x != 'hover');
      mouseInfo.event.setProp("classNames", newClassArray);
      // this.$refs[`eventTooltip${mouseInfo.event.id}`].$emit('close');
    },

    goToProject(projectId) {
      this.setDataLoading(true);
			this.fetchProjectDeliverableById(projectId).then(() => {
				this.setDataLoading(false);
				this.$router.push('/project/' + projectId);
			});
    },

    handleMoreLinkClick(clickInfo) {
      this.expandDate = clickInfo.date;
      this.calendarOptions.dayMaxEvents = clickInfo.allSegs.length;
      $(".fc-collapseButton-button").attr("disabled", false);
      return clickInfo.view.type;
    },

    handleHideClick(info) {
      this.calendarOptions.dayMaxEvents = true;
      this.expandDate = null;
      $(".fc-collapseButton-button").attr("disabled", true);
      // info.view.calendar.render();
    },

    formatDueDateTooltip(date) {
      if (date) {
        const dateMoment = this.$moment(date);
        // dateMoment.add(-1, 'day');
        return dateMoment.format("MMMM DD, YYYY");
      } else {
        return 'No due date';
      }
    }
  }
}
</script>